import i18next from 'i18next'

i18next.addResourceBundle('en', 'project', {
    update_project_modal: {
        title: 'Update Project',
        source_zip: 'Zip archive',
        source_folder: 'Folder',
        zip_hint: 'Click or drag a zip archive to this area',
        folder_hint: 'Click or drag a folder to this area',
        folder_selected_one: '{{count}} file is selected.',
        folder_selected_other: '{{count}} files are selected.',
        replace_note: 'The project content is replaced with the upload: project files absent from it are deleted.',
        only_zip: 'Only zip files are accepted.',
        confirm_button: 'Update',
    },
    update_module_modal: {
        title: 'Update Module',
        hint: 'Click or drag an Excel file to this area',
        only_excel: 'Only xls, xlsx, and xlsm files are accepted.',
        name_differs: 'The selected file differs from the current "{{file}}" module file. Ensure the correct file is chosen.',
        confirm_button: 'Update',
    },
    create_table_modal: {
        title: 'Create Table',
        module: 'Module',
        sheet: 'Sheet',
        table_type: 'Table Type',
        table_name: 'Table Name',
        base_type: 'Base Type',
        extends: 'Extends',
        datatype: 'Datatype',
        tested_table: 'Tested Table',
        transposed: 'Transposed',
        field: 'Field',
        field_title: 'Title',
        result_type: 'Result Type',
        input_arguments: 'Arguments',
        argument_type: 'Argument Type',
        argument_name: 'Argument Name',
        insert_argument: 'Insert Argument',
        delete_argument: 'Delete Argument',
        insert_row_above: 'Insert Row Above',
        insert_row_below: 'Insert Row Below',
        delete_row: 'Delete Row',
        insert_column_left: 'Insert Column Left',
        insert_column_right: 'Insert Column Right',
        delete_column: 'Delete Column',
        insert_record_before: 'Insert Record Before',
        insert_record_after: 'Insert Record After',
        delete_record: 'Delete Record',
        cell: 'Row {{row}}, column {{column}}',
        create: 'Create',
        created: 'Table created',
        created_description: 'The "{{table}}" table was created successfully.',
        create_failed: 'Failed to create the table',
        created_table_not_found: 'The table was written, but OpenL Studio could not open it after compilation.',
        modules_load_failed: 'Failed to load the project',
        options_load_failed: 'Failed to load the module worksheets',
        tested_table_load_failed: 'Failed to read the tested table',
        type_groups: {
            simple: 'Simple Types',
            vocabularies: 'Vocabularies',
            datatypes: 'Datatypes',
        },
        types: {
            datatype: 'Datatype',
            vocabulary: 'Vocabulary',
            constants: 'Constants',
            spreadsheet: 'Spreadsheet',
            smartRules: 'Smart Rules',
            simpleRules: 'Simple Rules',
            smartLookup: 'Smart Lookup',
            simpleLookup: 'Simple Lookup',
            rules: 'Rules',
            test: 'Test',
            run: 'Run',
            data: 'Data',
            environment: 'Environment',
            properties: 'Properties',
            freeForm: 'Free Form Table',
        },
        blocked: {
            module: 'Choose the module the table is written to.',
            table_name: 'Enter a table name: a letter or underscore first, then letters, digits or underscores.',
            sheet: 'Enter a sheet name Excel accepts: at most 31 characters, without / \\ * ? [ ] : or a leading or trailing apostrophe.',
            result_type: 'Enter the type the table returns.',
            partial_argument: 'Finish the argument: each one needs both a type and a name.',
            argument_names: 'Give every argument a distinct name, starting with a letter or underscore.',
            lookup_arguments: 'Add at least one argument: a lookup looks its result up by them.',
            vocabulary_type: 'Choose the type the vocabulary holds.',
            datatype: 'Choose a datatype with at least one field.',
            target: 'Choose the table to test.',
            body: 'Fill in the table below: it needs at least one row of values.',
            values: 'Correct the highlighted cells: a value does not match the type its column declares.',
        },
    },
    copy_table_modal: {
        title: 'Copy table "{{table}}"',
        table_name: 'Table Name',
        module: 'Module',
        sheet: 'Sheet',
        properties: 'Properties',
        property_name: 'Property',
        property_value: 'Value',
        delete_property: 'Delete property',
        version_major: 'Major',
        version_minor: 'Minor',
        version_variant: 'Variant',
        version_current: 'Current: {{version}}',
        copy: 'Copy',
        copied: 'Table copied',
        copied_description: 'The "{{table}}" table was copied successfully.',
        copy_failed: 'Failed to copy the table',
        copied_table_not_found: 'The table was copied, but OpenL Studio could not open it after compilation.',
        options_load_failed: 'Failed to load the table copy form',
    },
    notifications: {
        project_updated: 'Project updated',
        project_updated_description: 'The "{{project}}" project was updated successfully.',
        project_update_failed: 'Failed to update the project',
    },
})
